<template>
	<section class="video" v-if="video.id">
		<div class="container">
			<div class="content-text">
				<h2
					v-html="video.title"
					v-wow="{
						'animation-name': 'fadeInUp',
						'animation-duration': '1s',
					}"
				></h2>
			</div>

			<div class="fadeInLeft animated video">
				<div class="video-inner">
					<!-- VIDEO IMAGE -->
					<div class="video-container">
						<div class="video-content">
							<div class="video-cover see-video lazy" :data-key="video.id" @click="youtube">
								<div class="video-primary" :style="contentStyle">
									<span class="srt">title</span>
									<span class="srt">Play Icon</span>
									<div>
										<img src="~@/assets/img/play.svg" alt role="presentation" />
									</div>
								</div>
								<div class="video-primary" v-html="contentVideo"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'Video',
	data() {
		return {
			contentStyle: 'display:block;',
			contentVideo: '',
		}
	},
	props: ['id'],
	methods: {
		youtube() {
			this.contentStyle = 'display:none;'
			this.contentVideo =
				'<iframe class="video-itself" src="https://www.youtube.com/embed/' +
				this.video.id +
				'?autoplay=1&loop=1&playlist=' +
				this.video.id +
				'&mute=1" frameborder="0" allowfullscreen></iframe>'
		},
	},
	computed: {
		video() {
			return this.$t('Video')
		},
	},
}
</script>

<style scoped lang="scss">
h2 {
	margin-bottom: 30px;
	text-align: center;
	font-size: 50px;
}

.video-cover {
	background-image: url($pathToAssets+'/img/video-thumbnail.jpg');
}

@include mobile {
	h2 {
		font-size: 36px;
	}
}
</style>
